import { render, staticRenderFns } from "./company.vue?vue&type=template&id=3b7b3a66"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b7b3a66')) {
      api.createRecord('3b7b3a66', component.options)
    } else {
      api.reload('3b7b3a66', component.options)
    }
    module.hot.accept("./company.vue?vue&type=template&id=3b7b3a66", function () {
      api.rerender('3b7b3a66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/company.vue"
export default component.exports